module.exports = __webpack_public_path__ + "ss.49471e3c.svg";